module.exports = __webpack_public_path__ + "static/01-6aa54e020809693b4901cec2e2065f2a.jpg";